module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/snowboarding_7b27eb.jpg";